var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6529_52755",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.00366211,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6529_52755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0627 10.0036L5.93767 3.87858C5.72934 3.67025 5.62865 3.42372 5.63559 3.139C5.64253 2.85428 5.75017 2.60775 5.95851 2.39941C6.16684 2.19108 6.41337 2.08691 6.69809 2.08691C6.98281 2.08691 7.22934 2.19108 7.43767 2.39941L13.8335 8.81608C14.0002 8.98275 14.1252 9.17025 14.2085 9.37858C14.2918 9.58691 14.3335 9.79525 14.3335 10.0036C14.3335 10.2119 14.2918 10.4202 14.2085 10.6286C14.1252 10.8369 14.0002 11.0244 13.8335 11.1911L7.41684 17.6077C7.20851 17.8161 6.96545 17.9168 6.68767 17.9098C6.4099 17.9029 6.16684 17.7952 5.95851 17.5869C5.75017 17.3786 5.64601 17.1321 5.64601 16.8473C5.64601 16.5626 5.75017 16.3161 5.95851 16.1077L12.0627 10.0036Z",
    fill: "#4A7495"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevronRight.1a7312dfdbef43e1b4519ddd6ba6c129.svg";
export { ForwardRef as ReactComponent };